import { Component, ElementRef, Input, OnInit } from '@angular/core';

import { InsightsDisplayNameEnum } from '../../../../Mentions/enums/insights-display-name.enum';
import { MentionContentCustomizationEnum } from '../../../../Mentions/enums/mention-content-customization.enum';
import { Mention } from '../../../../Mentions/models/mention';
import { EntityTypeDefaultImageEnum } from '../../../../Misc/enums/entity-type-default-image.enum';
import { MentionCustomizationModel } from '../../../../../Monitor/Shared/models/mention-customization.model';
import { TopMentionsMetadataModel } from '../../../../Charts/models/top-mentions-metadata.model';
import { KeywordHighlightModel } from '../../../../Misc/models/keyword-highlight.model';
import { MediaTypeEnum } from '@Common/Basic/enums/media-type.enum';
import { KeywordLocationModel } from '../../../../Mentions/models/keyword-location.model';

@Component({
    selector: 'agpr-top-mentions-chart-card',
    templateUrl: './top-mentions-chart-card.component.html',
    styleUrls: ['./top-mentions-chart-card.component.scss'],
    standalone: false
})
export class TopMentionsChartCardComponent implements OnInit {
    @Input() mention: Mention;
    @Input() metadata: TopMentionsMetadataModel;
    @Input() mentionCustomization: MentionCustomizationModel;
    @Input() metadata1Color: string;
    @Input() metadata2Color: string;
    @Input() outletPhoto: string;

    bodyText: string;
    ave: number;
    outletUrl: string;
    contactUrl: string;

    highlightKeywords: KeywordHighlightModel[] = [];
    highlightKeywordsIndices: KeywordLocationModel[];
    canLinkOut: boolean = true;

    readonly preContent = '<div style="line-height: 1.5;">';
    readonly afterContent = '</div>';

    readonly mentionContentTypes = MentionContentCustomizationEnum;
    readonly insightsNameEnum = InsightsDisplayNameEnum;
    readonly imageDefault = EntityTypeDefaultImageEnum;

    constructor(
        public el: ElementRef
    ) {}

    ngOnInit(): void {
        this.setBodyText();
        if (this.mention.publication?.uuid) {
            this.outletUrl =  `Discover/profile/outlet/${this.mention.publication.uuid}`;
        }
        if (this.mention.author?.uuid) {
            this.contactUrl =  `Discover/profile/contact/${this.mention.author.uuid}`;
        }

        if (this.metadata.ave) {
            if (this.mentionCustomization.preferredCurrency !== 'USD') {
                this.ave = this.mention.adValueUsd / this.mentionCustomization.currencyRate;
            } else {
                this.ave = this.mention.adValueUsd;
            }
        }

        if (this.mentionCustomization.highlightKeywords) {
            this.highlightKeywords.push({
                class: 'agpr-highlight',
                caseSensitive: false,
                keywords: [...this.mention.contextualKeywords]
            });
            if (this.mentionCustomization.mentionContent === this.mentionContentTypes.lead) {
                this.highlightKeywordsIndices = this.mention.contexualKeywordIndices;
            } else {
                this.highlightKeywordsIndices = this.mention.summaryContextualKeywordIndices;
            }
        }

        if (this.mention.isLexisNexis ||
            ((this.mention.mediaType.id === MediaTypeEnum.TV
                || this.mention.mediaType.id === MediaTypeEnum.RADIO
            ) && Mention.isCriticalMention(this.mention))
        ) {
            this.canLinkOut = false;
        }
    }

    setBodyText() {
        let bodyLength: number = this.mention?.body?.length || 0;
        if (this.mentionCustomization.mentionContent === this.mentionContentTypes.lead || !this.mentionCustomization.mentionContent) {
            this.bodyText = this.mention?.body?.slice(0, 256);
        }
        if (this.mentionCustomization.mentionContent === this.mentionContentTypes.summary) {
            if (this.mention?.summary) {
                bodyLength = this.mention?.summary.length;
                this.bodyText = this.mention?.summary.slice(0, 256);
            } else {
                this.bodyText = this.mention?.body?.slice(0, 256);
            }
        }
        if (bodyLength && (this.mentionCustomization.mentionContent !== this.mentionContentTypes.headlineOnly) && (bodyLength > this.bodyText.length)) {
            this.bodyText += '...';
        }
    }

}
